import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/id-badge': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 0c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48h288zM336 464v-416h-288v416h288zM144 112c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96zM192 288c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM102.4 416c-12.4 0-22.4-8.6-22.4-19.2v-19.2c0-31.8 30.1-57.6 67.2-57.6 11.4 0 17.9 8 44.8 8 26.1 0 34-8 44.8-8 37.1 0 67.2 25.8 67.2 57.6v19.2c0 10.6-10 19.2-22.4 19.2h-179.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/id-badge.js
// module id = 1777
// module chunks = 0